import { render, staticRenderFns } from "./InitialRequest.vue?vue&type=template&id=02abed88"
import script from "./InitialRequest.vue?vue&type=script&lang=js"
export * from "./InitialRequest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports